/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
export const compareFields = (a: any, b: any): number => {
  if (a.flg_visualizacao && !b.flg_visualizacao) return -1;
  if (!a.flg_visualizacao && b.flg_visualizacao) return 1;
  return 0;
};
